import React from 'react';

import { connect } from 'react-redux';

import { Select } from '@nerdwallet/currency';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/home-affordability-calculator-selectors';
import {
  HomeAffordabilityInput,
  LOAN_TERM_ANALYTICS_HASH_VALUE,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';
import { loanTerms as LoanTermOptions } from '../hacControlOptions';
import { debouncedTrackInputEvent } from '../../../lib/analytics/trackers';
import useAnalytics from '../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const LoanTermInput: React.FC<HomeAffordabilityInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const value = inputs?.loanTerm;
  const errorMessage = validations?.loanTerm?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'loanTerm',
        inputType: INPUT_TRACKING_TYPES.RANGE,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
        mapValue: (target: string) =>
          LOAN_TERM_ANALYTICS_HASH_VALUE[target] || null,
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        field_value: e.target.value,
        field_type: 'drop-down',
        entityName: 'loan_term',
        field: 'Loan Term',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'loanTerm',
      calculator: HOME_AFFORDABILITY,
    });
  };

  return (
    <Select
      options={LoanTermOptions}
      value={value}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      label={label}
      className={className}
      tooltip={tooltip}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(LoanTermInput);
